export const APPOINTMENT_CHANGE_STATUS = {
  CANCELLED: "CANCELLED",
  NO_SHOW: "NO_SHOW",
} as const;

export const APPOINTMENT_STATUS_CHANGE_MODAL_WIDTH = "450px";
export const APPOINTMENT_STATUS_CHANGE_REASON_MIN_ROWS = 5;

export const APPOINTMENT_STATUS_CHANGE_LABEL = {
  REASON: "Reason",
  CONFIRM: "Confirm",
  CANCEL: "Cancel",
} as const;

export const APPOINTMENT_STATUS_CHANGE_MESSAGE = {
  REASON_REQUIRED: "Reason is a required field",
  CANCEL_INTENT:
    "You want to cancel this patient's appointment request with you.",
  CANCEL_CONFIRM:
    "Please confirm that you have provided a reason for the cancellation.",
  NO_SHOW_CONFIRM:
    "Please confirm that you want to mark this appointment as 'No Show'.",
} as const;

export const APPOINTMENT_STATUS_CHANGE_REASON_PLACEHOLDER = {
  CANCELLED: "Please enter the reason for the appointment cancellation",
  NO_SHOW: 'Please enter the reason for the "No Show" appointment status',
} as const;

export const APPOINTMENT_STATUS_CHANGE_INVALIDATE_QUERY_KEYS = [
  ["appointment-list"],
  ["appointment-list-v2"],
  ["future-appointment"],
] as const;
